(function ($) {
    "use strict";
    var env;

    function initialize() {
        env = $('html').attr('data-env');
        if (localStorage.getItem(env) === null) {
            localStorage.setItem(env, '');
        }
    }

    /**
     * Set a value by key in the environment's local storage.
     * @param key
     * @param value
     */
    function set(key, value) {
        var data;

        if (typeof(value) === 'object' || typeof(value) === 'string') {
            if (typeof(value) === 'object') {
                data = JSON.stringify(value);
            } else if (typeof(value) === 'string') {
                data = value;
            }
        } else if(typeof(value) === 'number') {
            data = value;
        }

        if (data) {
            var oldData = localStorage.getItem(env);
            var newData = {};

            if (oldData === undefined || oldData === null || oldData.length === 0) {
                newData[key] = data;
            } else {
                oldData = JSON.parse(oldData);
                oldData[key] = data;
                newData = oldData;
            }

            localStorage.setItem(env, JSON.stringify(newData));

            return true;
        }

        return false;
    }

    /**
     * Return the value for the given key found in the environment's local storage.
     * @param key
     */
    function get(key) {
        var value = localStorage.getItem(env);

        if (typeof(value) === 'string' && value.length > 0) {
            var data = JSON.parse(value);

            if (data.hasOwnProperty(key)) {
                if (typeof(data[key]) === 'string' && data[key].length > 0) {
                    var result = false;
                    try {
                        result = JSON.parse(data[key]);
                    } catch (e) {
                        result = data[key];
                    }

                    return result;
                } else {
                    return data[key];
                }
            }
        }

        return null;
    }

    /**
     * Remove an item from the environment's local storage.
     * @param key
     */
    function remove(key) {
        var data = localStorage.getItem(env);

        if (typeof(data) === 'string' && data.length > 0) {
            data = JSON.parse(data);
            if (data.hasOwnProperty(key)) {
                delete data[key];
            }
            localStorage.setItem(env, JSON.stringify(data));
            return true;
        }

        return false;
    }

    /**
     * Clear all the data from the environment's local storage.
     */
    function removeAll() {
        var data = localStorage.getItem(env);

        if (typeof(data) === 'string' && data.length > 0) {
            data = JSON.parse(data);
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    delete data[property];
                }
            }

            localStorage.setItem(env, JSON.stringify(data));
            return true;
        }

        return false;
    }

    /**
     * List all the data in the environment's local storage.
     * @returns {{}}
     */
    function getAll() {
        var data = localStorage.getItem(env);
        var archive = {};

        if (typeof(data) === 'string' && data.length > 0) {
            data = JSON.parse(data);
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    if (typeof(data[property]) === 'string') {
                        if (data[property].length > 0) {
                            try {
                                archive[property] = JSON.parse(data[property]);
                            } catch (e) {
                                archive[property] = data[property];
                            }

                        } else {
                            archive[property] = data[property];
                        }
                    } else {
                        archive[property] = data[property];
                    }
                }
            }
        }

        return archive;
    }

    function addTo(key, value) {
        var data = localStorage.getItem(env);
        var list = [];

        if (typeof(data) === 'string' && data.length > 0) {
            var oldElement = get(key);

            if(typeof(oldElement) === 'object') {
                for (var i in oldElement) {
                    if (oldElement.hasOwnProperty(i)) {
                        list.push(oldElement[i]);
                    }
                }
            } else if (typeof(oldElement) === 'string' || typeof(oldElement) === 'number') {
                list.push(oldElement);
            }
        }

        var newElement = parseData(value);

        if(newElement) {
            list.push(newElement);
        }

        if(list.length > 0) {
            return set(key, list);
        }

        return false;
    }

    function removeFrom(key, value) {
        var data = localStorage.getItem(env);
        var list = [];

        if (typeof(data) === 'string' && data.length > 0) {
            var oldElement = get(key);

            if(typeof(oldElement) === 'object') {
                for (var i in oldElement) {
                    if (oldElement.hasOwnProperty(i)) {
                        if(oldElement[i].toString().localeCompare(value.toString()) !== 0) {
                            list.push(oldElement[i]);
                        }
                    }
                }
            } else if (typeof(oldElement) === 'string' || typeof(oldElement) === 'number') {
                if(oldElement.toString().localeCompare(value.toString()) !== 0) {
                    list.push(oldElement);
                }
            }
        }

        if(set(key, list)) {
            if(list.indexOf(value) === -1) {
                return true;
            }
        }

        return false;
    }

    function parseData(value) {
        var data;

        if (typeof(value) === 'object' || typeof(value) === 'string') {
            if (typeof(value) === 'object') {
                data = JSON.stringify(value);
            } else if (typeof(value) === 'string') {
                data = value;
            }
        } else if(typeof(value) === 'number') {
            data = value;
        }

        return data;
    }

    /**
     * Return true if an item DOES NOT exist in the environment's local storage, or
     * false if it does.
     * @param key
     * @returns {boolean}
     */
    function isEmpty(key) {
        var data = localStorage.getItem(env);

        if (typeof(data) === 'string' && data.length > 0) {
            data = JSON.parse(data);
            if (data.hasOwnProperty(key)) {
                return data[key] === null || data[key] === undefined || data[key].length === 0;
            }
        }

        return true;
    }

    /**
     * Return true if an item EXISTS in the environment's local storage, or
     * false if it is does not.
     * @param key
     * @returns {boolean}
     */
    function isSet(key) {
        var data = localStorage.getItem(env);

        if (typeof(data) === 'string' && data.length > 0) {
            data = JSON.parse(data);
            if (data.hasOwnProperty(key)) {
                return data[key] !== null && data[key] !== undefined && data[key].length > 0;
            }
        }

        return false;
    }

    window.storage = {
        set: set,
        addTo: addTo,
        removeFrom: removeFrom,
        get: get,
        getAll: getAll,
        remove: remove,
        removeAll: removeAll,
        isEmpty: isEmpty,
        isSet: isSet
    };

    initialize();
})(jQuery);